import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class EditableText extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      isEditing: this.props.isEditing
    }
  }

  enterEditMode() {
    this.setState({
      isEditing: true
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value != this.state.value) {
      this.setState({
        value: nextProps.value
      })
    }
  }

  makeChange(newValue) {
    this.setState({
      isEditing: false
    });

    this.props.onUpdate(newValue);
  }

  render() {
    if (this.state.isEditing) {
      return <this.props.InputComponent
        className={this.props.textClassName}
        value={this.state.value}
        placeholder={this.props.placeholder}
        onUpdate={this.makeChange.bind(this)}/>;
    } else {
      return (
        <this.props.TextComponent onClick={this.enterEditMode.bind(this)}/>
      );
    }
  }

}

EditableText.propTypes = {
  value: PropTypes.string,
  onUpdate: PropTypes.func,
  isEditing: PropTypes.bool
}

EditableText.defaultProps = {
  isEditing: false,
  InputComponent: () => <input type='text'/>,
  TextComponent: () => <span>Hello</span>
}

export default EditableText;



// WEBPACK FOOTER //
// ./components/UI/Form/EditableText.jsx